import fp from "lodash/fp";

import {
	FilterColumn,
	FilterColumnDateProps,
	FilterFormatFn,
	FilterRow,
} from "types";

export const getIsRowLayout = (columns: any[]): columns is Array<Array<any>> =>
	columns.some(Array.isArray);

export const getAllColumns = (
	columns: Array<FilterColumn | FilterColumnDateProps>,
	expandableRows: FilterRow[],
) => {
	return [...columns?.flatMap(c => c), ...expandableRows?.flatMap(r => r)];
};

export const mapFormattersFromColumns = (
	columns: Array<FilterColumn | FilterColumnDateProps>,
): Record<string, FilterFormatFn> => {
	const temp1 = columns.filter(c => {
		if (!!c.formatLabel) {
			return true;
		}
		if ("groupColumns" in c) {
			return !!c.groupColumns;
		}
		return false;
	});

	const temp2 = temp1.map(c => {
		let result: Record<string, FilterFormatFn> = {};

		if (c?.name && c.formatLabel) {
			result[c.name] = c.formatLabel;
		}

		// if (c?.nameFrom && c.formatLabel) {
		// 	result[c.nameFrom] = c.formatLabel;
		// }

		// if (c?.nameTo && c.formatLabel) {
		// 	result[c.nameTo] = c.formatLabel;
		// }

		if ("groupColumns" in c && c?.groupColumns) {
			c.groupColumns.forEach(col => {
				if (col.formatLabel) {
					result[col.name] = col.formatLabel;
				}
			});
		}

		return result;
	});

	return temp2.reduce<Record<string, FilterFormatFn>>(fp.merge, {});
};

export const findColumnInAll = (
	allColumns: Array<FilterColumn | FilterColumnDateProps>,
	filterKey: string,
) => {
	return allColumns.find(c => {
		return filterKey === c.name;
	});
};
